module.exports = __webpack_public_path__ + "img/5.1424dab8.png";